module.exports = __webpack_public_path__ + "img/Misi2-2-1Ilustrasi Thinking.413c66cb.png";